import { ResolveFn, RedirectCommand, Router } from '@angular/router';
import { inject } from '@angular/core';
import { of, catchError, switchMap, tap } from 'rxjs';
import { ClassificationRatesService } from '../../services/classification-rates.service';
import { LCPUserService } from 'src/app/shared/services/lcp-user/lcp-user.service';
import { QueryClassificationRateByIdArgs } from 'src/app/services/apollo/gateway.types';
import { ClassificationRateFormMode } from '../enums/classification-rate-form-mode.enum';
import { MASTER_WAGE_ROUTE } from '../enums/manage-wage-rates-form.route';
import { MasterWageResolverDataResponse } from '../interfaces/master-wage-resolver-response.interface';
import { MasterWageRateFormService } from '../services/master-wage-rate-form.service';
import { resolveFormMode } from '../utils/resolveFormMode';

export const manageMasterWageRatesFormResolver: ResolveFn<
  MasterWageResolverDataResponse | RedirectCommand
> = route => {
  const _classificationRatesService = inject(ClassificationRatesService);
  const _masterWageRateFormService = inject(MasterWageRateFormService);
  const _lcpUserService = inject(LCPUserService);
  const _router = inject(Router);

  const id = route.paramMap.get('id');
  const jurisdictionId = route.paramMap.get('jurisdictionId');
  const tenantId = _lcpUserService.getUserTenantIdValue();
  const currentPath = _router.getCurrentNavigation()?.finalUrl?.toString();

  const redirectCommand = new RedirectCommand(
    _router.parseUrl(MASTER_WAGE_ROUTE.HOME)
  );

  const formMode = resolveFormMode(currentPath);

  if (formMode === ClassificationRateFormMode.AddMasterWage) {
    _masterWageRateFormService.setFormMode(formMode);
    _masterWageRateFormService.setClassificationRateData({});
    return of({ formMode, classificationRate: null });
  }

  const vars: QueryClassificationRateByIdArgs = {
    id,
    jurisdictionId,
    tenantId,
  };

  return _classificationRatesService
    .getClassificationRateInformationById(vars, 'cache-first')
    .pipe(
      switchMap(({ classificationRateById }) => {
        if (!formMode || !Object.values(classificationRateById).length)
          return of(redirectCommand);

        return of({
          formMode,
          classificationRate: classificationRateById,
        }).pipe(
          tap(({ formMode, classificationRate }) => {
            _masterWageRateFormService.setFormMode(formMode);
            _masterWageRateFormService.setClassificationRateData(
              classificationRate
            );
          })
        );
      }),
      catchError(() => of(redirectCommand))
    );
};
